import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button} from '@guestapp/old-ui-kit';
import {StatusModal} from '@chekin/shared';

export const StyledStatusModal = styled(StatusModal)`
  &-content {
    padding: 48px 24px;
    height: 100vh;
    & .modal__title {
      margin: 24px auto 0;
    }

    & .modal__description {
      margin: 24px auto 0;
    }
  }

  @media (min-width: ${DEVICE.mobileXL}) {
    &-content {
      max-width: 375px;
      height: auto;
    }
  }
`;

export const OkButton = styled(Button)`
  max-width: 294px;
  margin-top: 48px;
`;
